export default __webpack_public_path__ + "images/assets/2d8db5a97de547a7d5128e61beb76bb8.svg";